import React from 'react';
import { mockData } from '../mock';
import { Phone, Mail, MessageCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1A3A2E] text-white py-12">
      <div className="container mx-auto px-6">
        {/* Partner Logos Section */}
        <div className="mb-12 pb-12 border-b border-[#E8F5E0]/20">
          <h4 className="font-bold text-lg mb-6 text-center">Unsere Partner</h4>
          <div className="grid grid-cols-3 md:grid-cols-6 gap-8 items-center">
            {mockData.partners.map((partner, idx) => (
              <div
                key={idx}
                className="p-2 rounded-lg flex items-center justify-center h-56 transition-all duration-300"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-full w-full object-contain hover:scale-105 transition-all duration-300"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-8">
          <div>
            <div className="bg-white rounded-lg p-3 inline-block mb-6">
              <img 
                src="/novatus-logo.png" 
                alt="Novatus Energie" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-[#E8F5E0]/80 leading-relaxed">
              {mockData.company.tagline}
            </p>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Kontakt</h4>
            <div className="space-y-3">
              <a
                href={`tel:${mockData.company.phone.replace(/\s/g, '')}`}
                className="flex items-center space-x-3 text-[#E8F5E0]/80 hover:text-[#E8F5E0] transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span>{mockData.company.phone}</span>
              </a>
              <a
                href={`mailto:${mockData.company.email}`}
                className="flex items-center space-x-3 text-[#E8F5E0]/80 hover:text-[#E8F5E0] transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span>{mockData.company.email}</span>
              </a>
              <div className="flex items-start space-x-3 text-[#E8F5E0]/80">
                <MessageCircle className="w-4 h-4 mt-1" />
                <div>
                  <p>{mockData.company.address.street}</p>
                  <p>{mockData.company.address.zip} {mockData.company.address.city}</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Rechtliches</h4>
            <div className="space-y-2 text-[#E8F5E0]/80 text-sm">
              <p><strong>Geschäftsführer:</strong><br/>{mockData.company.legal.ceo}</p>
              <p><strong>Registergericht:</strong><br/>{mockData.company.legal.court}</p>
              <p><strong>Registernummer:</strong><br/>{mockData.company.legal.hrb}</p>
              <p><strong>USt-IdNr.:</strong><br/>{mockData.company.legal.ustId}</p>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-4">Schnelllinks</h4>
            <div className="space-y-2">
              <a href="#services" className="block text-[#E8F5E0]/80 hover:text-[#E8F5E0] transition-colors">
                Leistungen
              </a>
              <a href="#about" className="block text-[#E8F5E0]/80 hover:text-[#E8F5E0] transition-colors">
                Über uns
              </a>
              <a href="#blog" className="block text-[#E8F5E0]/80 hover:text-[#E8F5E0] transition-colors">
                Blog
              </a>
              <a href="#contact" className="block text-[#E8F5E0]/80 hover:text-[#E8F5E0] transition-colors">
                Kontakt
              </a>
              <a href="/impressum" className="block text-[#E8F5E0]/80 hover:text-[#E8F5E0] transition-colors">
                Impressum
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#E8F5E0]/20 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-[#E8F5E0]/60 text-sm">
            <p className="mb-4 md:mb-0">
              © {new Date().getFullYear()} {mockData.company.fullName}. Alle Rechte vorbehalten.
            </p>
            <div className="flex space-x-6">
              <a href="/impressum" className="hover:text-[#E8F5E0] transition-colors">
                Impressum
              </a>
              <a href="/datenschutz" className="hover:text-[#E8F5E0] transition-colors">
                Datenschutz
              </a>
              <a href="/agb" className="hover:text-[#E8F5E0] transition-colors">
                AGB
              </a>
              <a href="/widerruf" className="hover:text-[#E8F5E0] transition-colors">
                Widerruf
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;